import find from "lodash/find";

import {Part} from "./part";
import {LayoutType} from "../constants";
import {windowThumbnail} from "../assets";
import {NN} from "../../../../misc/utils";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {IntermediatePart} from "./intermediatePart";
import {setFeatureParent} from "../../../visComponents/featureParent";

export class Window extends Part {
  static id = 'Window';

  constructor() {
    super(true, false, PartMenuType.Simple);
    this.partId = 'window';
    this.menuType = PartMenuType.Simple;
    this.partName = 'Window';
    this.translateId = "visualizer.bathroom.window";
    this.homePageTitle = 'Window Coverings';
    this.dbName = 'Window Covering';
    this.partThumbnail = windowThumbnail;
  }

  load(dbFeature) {
    const isWindowCovering = dbFeature.groupName === 'Window Covering';
    const isWindow = dbFeature.groupName === 'Window';

    if (!isWindowCovering && !isWindow)
      return false;

    const part = new WindowBody();
    setFeatureParent(part, this); // shared function + _parent ref, no closure per feature

    if (!this.categoryEnabled) {
      this.categoryEnabled = true
    }

    if (isWindowCovering) {
      part.load(dbFeature);
    } else {
      this.windowDefault = part;
      this.windowDefault.dbFeature = dbFeature;
    }
    return true
  }

  setLayers(layout, placeholdersNeeded) {
    if (layout.type === LayoutType.Small)
      return null;

    if (!this.activeFeature)
      return null;

    const res = [];
    // let s3Binding = find(this.activeFeature.dbFeature.s3Bindings, {entityID: this.activeFeature.featureDefinitionId()});
    let s3Binding = find(this.activeFeature.dbFeature.s3Bindings, {entityID: this.activeFeature.featureDefinitionId(), layout: layout.getCurrentLayoutAbbreviation()});
    if (!s3Binding) {
      s3Binding =  find(this.activeFeature.dbFeature.s3Bindings, {entityID: this.activeFeature.featureDefinitionId()});
    }

    if (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature) {
      s3Binding = find(this.placeholderFeature.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this.placeholderFeature), layout: layout.getCurrentLayoutAbbreviation()});
      if (!s3Binding) {
        s3Binding =  find(this.placeholderFeature.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this.placeholderFeature)});
      }
    }

    this.activeFeature.layer.fromS3Binding(s3Binding);
    // this.activeFeature.layer.addTo(res);

    if (this.placeholderFeature) {
      let s3Binding = find(this.placeholderFeature.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this.placeholderFeature), layout: layout.getCurrentLayoutAbbreviation()});
      if (!s3Binding) {
        s3Binding =  find(this.placeholderFeature.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this.placeholderFeature)});
      }
      this.placeholderFeature.layer.fromS3Binding(s3Binding);
    }

    if (this.windowDefault && this.windowDefault.dbFeature.s3Bindings) {
      const dbFeature = this.windowDefault.dbFeature;
      s3Binding = dbFeature.s3Bindings[0];
      this.windowDefault.layer.fromS3Binding(s3Binding);
      this.windowDefault.layer.addTo(res);
    }

    (placeholdersNeeded && !this.placeholderChanged && this.placeholderFeature)
      ? this.placeholderFeature.layer.addTo(res)
      : this.activeFeature.layer.addTo(res);

    return res;
  }

  setDefault() {
    const hardCodedDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Stylewise Snowblind");
    });
    const placeholderDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
    });
    this.activeFeature = hardCodedDefault || this.features[0];
    this.placeholderFeature = placeholderDefault || this.features[0];
  }

  navigationItem() {
    return new DesignNavigationItem(this.partName, this);
  }

  setZIndex(zIndexes) {
    // if (layout.type === LayoutType.Large) {
    //     NN(this.windowDefault, _ => _.layer.zIndex = Z.layouts.Large.Window_Default);
    //     NN(this.activeFeature, _ => _.layer.zIndex = Z.layouts.Large.Window_Covering);
    // }
    if(zIndexes) {
      NN(this.windowDefault, _ => _.layer.zIndex = zIndexes.Window_Default);
      NN(this.activeFeature, _ => _.layer.zIndex = zIndexes.Window_Covering);
      if(this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Window_Covering;
      }
    }
  }

  subParts() {
    return [{
      text: this.partName,
      part: this
    }]
  }

}

class WindowBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'window';
    this.partName = 'Window';
    this.translateId = "visualizer.bathroom.window";
  }

  load(dbFeature) {
    super.load_.call(this.getParent(), dbFeature, this, false);
  }
}
